
export default class RedemptionResponse {

  constructor(jsonResponse) {
    if (jsonResponse) {
      this.id = jsonResponse["id"];
      this.transactionId = jsonResponse["inbound-transaction-id"];
      this.registrationId = jsonResponse["registration-id"];
      this.status = jsonResponse["status"];
      this.requestDate = jsonResponse["request-date"];
    }
  }
}
